import { useQuery } from '@tanstack/react-query';
import { organizationService, GetOrganizationsParams } from '@services/organization';

export const useOrganizations = (params: GetOrganizationsParams = {}) => {
  return useQuery({
    queryKey: ['organizations', params],
    queryFn: () => organizationService.getOrganizations(params),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export default useOrganizations;